<template>
	<div class="pool-info">
		<table>
			<tbody>
			<tr v-for="(item,key) in items" :key="key">
				<td>
					<img src="" alt="img">
				</td>
				<td>
					{{ item }}
				</td>
			</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
import {web3} from "@project-serum/anchor";

export default {
	name: "PoolInfo",
	props: {
		pool: {
			type: web3.PublicKey,
			required: true
		}
	},
	data() {
		return {
			items: [],
		}
	},
	methods: {
		getPoolItems: function() {
			//TODO connection
			//TODO GetProgramAccounts (filtered)
			//Add to items
		}
	},
	mounted() {
		this.getPoolItems()
	}
}
</script>

<style scoped>

</style>